import { A4uAdd as IconComponent } from '@adobe/react-spectrum-workflow/dist/Add.js';
import { Icon } from '@adobe/react-spectrum/Icon';
import React from 'react';
export default function Add(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}